import React from 'react';
import { Calendar } from 'lucide-react';
import './DateFilter.css';

interface DateFilterProps {
  year: number;
  month: number;
  onYearChange: (year: number) => void;
  onMonthChange: (month: number) => void;
}

const DateFilter: React.FC<DateFilterProps> = ({
  year,
  month,
  onYearChange,
  onMonthChange
}) => {
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 5 }, (_, i) => currentYear - 2 + i);
  
  const months = [
    { value: 1, label: 'Enero' },
    { value: 2, label: 'Febrero' },
    { value: 3, label: 'Marzo' },
    { value: 4, label: 'Abril' },
    { value: 5, label: 'Mayo' },
    { value: 6, label: 'Junio' },
    { value: 7, label: 'Julio' },
    { value: 8, label: 'Agosto' },
    { value: 9, label: 'Septiembre' },
    { value: 10, label: 'Octubre' },
    { value: 11, label: 'Noviembre' },
    { value: 12, label: 'Diciembre' }
  ];

  return (
    <div className="date-filter">
      <div className="date-filter-header">
        <Calendar size={20} />
        <h3>Filtrar por Fecha</h3>
      </div>
      
      <div className="date-filter-controls">
        <div className="filter-group">
          <label htmlFor="year-select">Año:</label>
          <select
            id="year-select"
            value={year}
            onChange={(e) => onYearChange(parseInt(e.target.value))}
            className="filter-select"
          >
            {years.map(y => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>
        </div>

        <div className="filter-group">
          <label htmlFor="month-select">Mes:</label>
          <select
            id="month-select"
            value={month}
            onChange={(e) => onMonthChange(parseInt(e.target.value))}
            className="filter-select"
          >
            {months.map(m => (
              <option key={m.value} value={m.value}>{m.label}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default DateFilter;
